import { z as e } from "zod";
//#region src/message.ts
var t = e.object({
	text: e.string().optional(),
	type: e.enum([
		"text",
		"file",
		"button",
		"offers"
	]),
	status: e.enum([
		"info",
		"success",
		"error",
		"warning"
	]).nullable().optional(),
	button_text: e.string().optional(),
	button_redirect_type: e.string().optional(),
	button_url: e.string().optional(),
	resume_product_type: e.string().optional()
}), n = e.object({
	content: e.array(t).optional(),
	context: e.enum(["borrower_platform"]).optional(),
	state: e.string().optional(),
	version: e.string()
}), r = e.object({
	id: e.number(),
	first_name: e.string(),
	last_name: e.string().nullable(),
	email: e.email(),
	phone: e.string().nullable(),
	created_at: e.iso.datetime({ offset: !0 })
}), i = e.object({
	id: e.string(),
	content: n,
	is_resolved: e.boolean(),
	resolved_by: r.nullable().optional(),
	resolved_at: e.string().nullable().optional(),
	is_shared_with_borrower: e.boolean().optional(),
	commentable_type: e.string(),
	commentable_id: e.union([e.string(), e.number()]),
	created_at: e.string()
});
//#endregion
export { i as commentSchema, n as messageSchema };
